/**
 * 다운로드 HTML self-contained 화를 위한 제네릭 헬퍼.
 * (DSD 다운로더의 도메인 무관 부분을 추출/일반화 — DSD 원본은 수정하지 않는다.)
 */

/** 문서의 모든 stylesheet 규칙을 합쳐 inline 가능한 CSS 문자열로 반환. */
export function extractAllStyles(): string {
  const cssTexts: string[] = [];
  for (const sheet of document.styleSheets) {
    try {
      for (const rule of sheet.cssRules) {
        cssTexts.push(rule.cssText);
      }
    } catch {
      // cross-origin stylesheet — skip
    }
  }
  return cssTexts.join("\n");
}

/** public asset(svg)를 data URI 로 변환. 실패 시 null. */
export async function fetchAssetAsDataUri(
  path: string,
): Promise<string | null> {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export const FONT_IMPORT = `@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");`;
